import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gl0011',
    ecrans: ['00-2']
});
